import { useEffect } from 'react';

export interface Shortcut {
  /** Key string (e.g. "k", "Escape", "ArrowDown"). */
  key: string;
  /** Cmd (macOS) veya Ctrl (Win/Linux) — platform-aware. */
  meta?: boolean;
  shift?: boolean;
  alt?: boolean;
  handler: (e: KeyboardEvent) => void;
  /** Input/textarea/contentEditable içindeyken de tetiklensin mi (default: false). */
  allowInInputs?: boolean;
  /** Etiket — CommandPalette ve "Klavye Kısayolları" overlay'i için. */
  description?: string;
}

function isInputLike(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable;
}

/**
 * Klavye kısayolu kaydet.
 * `meta: true` macOS'ta Cmd, diğer platformlarda Ctrl ile eşleşir.
 */
export function useKeyboardShortcuts(shortcuts: Shortcut[]): void {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      for (const s of shortcuts) {
        const metaPressed = e.metaKey || e.ctrlKey;
        const meta = !!s.meta;
        if (s.key.toLowerCase() !== e.key.toLowerCase()) continue;
        if (meta !== metaPressed) continue;
        if (!!s.shift !== e.shiftKey) continue;
        if (!!s.alt !== e.altKey) continue;
        if (!s.allowInInputs && isInputLike(e.target)) continue;
        e.preventDefault();
        s.handler(e);
        break;
      }
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [shortcuts]);
}
